import law from '../../rebase/common/main.js'

export default {
  ...law,
  env: 'development',
  stylesheet: '/admin_panel_development.css',
  files_url: 'http://localhost:3002/',
  base_api_url: 'http://localhost:3000/',
  // conv-svc / intake operation slug — routes the readonly chatbot panel to this tenant's API
  intake_operation_slug: 'rebase',
  hr_email: 'kaplanharel@gmail.com',
  operation_email: 'kaplanharel@gmail.com',
  full_env_name: 'suitup_law_development',
  company_panel_url: 'http://localhost:5173/',
  favicon: "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>💥</text></svg>"
}
